module.exports = __webpack_public_path__ + "img/case_bottom_004.0b8faffb.png";